/* Large Canvas Art product page (template product.large-canvas ONLY; loaded behind
   the template-suffix check in layout/theme.liquid). Presentation only: every choice
   still goes through the theme's own radio inputs, form and Add to Cart button, so
   variant IDs, prices and checkout are exactly the theme's. Nothing here builds a
   second form or sets a price. */
(function () {
  'use strict';

  var SWATCH = { 'print only': 'printonly', 'unframed': 'unframed', 'black': 'black', 'white': 'white', 'light oak look': 'oak', 'dark kiaat look': 'kiaat' };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function variants() {
    // Impulse keeps the variant list in a hidden <textarea> inside the product blocks.
    var out = null;
    $$('[data-product-blocks] textarea.hide, textarea[data-variant-json]').some(function (t) {
      try { var j = JSON.parse(t.value || t.textContent); if (Array.isArray(j) && j.length && j[0].options) { out = j; return true; } } catch (e) {}
      return false;
    });
    return out || [];
  }

  function wrapperOf(input) { return input.closest('.variant-wrapper'); }

  function selectedOptions() {
    return $$('.variant-wrapper').map(function (w) {
      var c = $('input[type=radio]:checked', w) || $('select', w);
      return c ? c.value : null;
    });
  }

  function money(cents) {
    // Match the format the page itself uses for the main price (e.g. "R7495.00"),
    // so the cards never show a second, different-looking number.
    var shown = (($('[data-product-price]') || {}).textContent || '').replace(/\s+/g, '');
    var m = /^R(\d+)\.(\d\d)$/.exec(shown);
    if (m) return 'R' + (cents / 100).toFixed(2);
    var t = window.theme || {};
    try {
      if (t.Currency && t.Currency.formatMoney && t.settings && t.settings.moneyFormat) return t.Currency.formatMoney(cents, t.settings.moneyFormat);
    } catch (e) {}
    return null;
  }

  /* 1. Options with a single value (portrait size; mounted canvas type) become one spec line. */
  function specLine() {
    var parts = [];
    $$('.variant-wrapper').forEach(function (w) {
      var inputs = $$('input[type=radio]', w);
      if (inputs.length === 1) {
        var label = ($('.variant__label', w) || {}).textContent || '';
        label = label.replace(/\s+/g, ' ').trim();
        if (/type/i.test(label)) { w.classList.add('sg-lca-single'); return; }   // covered by the feature line
        parts.push({ label: label.replace(/:.*/, ''), value: inputs[0].value.replace(/\s*x\s*/i, ' × ').replace(/cm$/i, ' cm') });
        w.classList.add('sg-lca-single');
      }
    });
    if (!parts.length || $('.sg-lca-spec')) return;
    var p = document.createElement('p');
    p.className = 'sg-lca-spec';
    p.innerHTML = parts.map(function (x) {
      var l = x.label.charAt(0).toUpperCase() + x.label.slice(1).toLowerCase();
      return '<span class="sg-lca-spec__label">' + l + '</span><span class="sg-lca-spec__box">' + x.value + '</span>';
    }).join('');
    var first = $('.variant-wrapper:not(.sg-lca-single)') || $('.variant-wrapper');
    if (first) first.parentNode.insertBefore(p, first);
  }

  /* 2. Frame options become cards: swatch + name + that frame's real variant price. */
  function frameCards() {
    var fw = $$('.variant-wrapper').filter(function (w) { return /frame/i.test(($('.variant__label', w) || {}).textContent || ''); })[0];
    if (!fw) return null;
    fw.classList.add('sg-lca-frames');
    var lab = $('.variant__label', fw);
    if (lab && lab.firstChild && lab.firstChild.nodeType === 3) lab.firstChild.textContent = 'Choose your frame ';
    $$('.variant-input', fw).forEach(function (vi) {
      var label = $('label', vi); if (!label || $('.sg-lca-swatch', label)) return;
      var val = vi.getAttribute('data-value') || '';
      var key = SWATCH[val.toLowerCase()] || 'unframed';
      var name = label.textContent.replace(/\s+/g, ' ').trim().replace(/\s+Look$/i, '');
      // "Unframed" read like a loose piece of canvas (Craig, 2026-10-16). It is a mounted canvas,
      // ready to hang, with no floater frame. Display only: the option VALUE stays "Unframed".
      var sub = '';
      if (key === 'unframed') { name = 'No frame'; sub = '<span class="sg-lca-card__sub">Mounted, ready to hang</span>'; }
      // Print only (2026-10-20): the canvas printed with a mirror bleed and rolled in a tube, not stretched. The cheapest choice.
      if (key === 'printonly') { name = 'Print only'; sub = '<span class="sg-lca-card__sub">Rolled in a tube</span>'; }
      label.innerHTML = '<span class="sg-lca-swatch sg-lca-swatch--' + key + '" aria-hidden="true"></span>' +
        '<span class="sg-lca-card__text"><span class="sg-lca-card__name">' + name + '</span>' + sub + '<span class="sg-lca-card__price"></span></span>';
    });
    return fw;
  }

  function framePrices(fw) {
    if (!fw) return;
    var vs = variants(); if (!vs.length) return;
    // Only show per-card prices when the page price is in rand: overseas visitors see a
    // converted price elsewhere on the page, and a rand figure here would contradict it.
    var shown = ($('[data-product-price]') || {}).textContent || '';
    var useRand = /^\s*R\s?\d/.test(shown);
    var idx = $$('.variant-wrapper').indexOf(fw);
    var sel = selectedOptions();
    $$('.variant-input', fw).forEach(function (vi) {
      var slot = $('.sg-lca-card__price', vi); if (!slot) return;
      if (!useRand) { slot.textContent = ''; return; }
      var want = sel.slice(); want[idx] = vi.getAttribute('data-value');
      var v = vs.filter(function (x) { return x.options.every(function (o, i) { return want[i] == null || o === want[i]; }); })[0];
      var m = v ? money(v.price) : null;
      slot.textContent = v ? (v.available === false ? 'Sold out' : (m || '')) : '';
    });
  }

  /* 3. Accordion names from the brief. */
  function renameTabs() {
    $$('.collapsible-trigger-btn').forEach(function (b) {
      var t = b.childNodes[0];
      if (t && t.nodeType === 3 && /^\s*description\s*$/i.test(t.textContent)) t.textContent = 'About this artwork';
    });
  }

  /* 4. Sticky add-to-cart bar: appears once the real button has scrolled away, and
        clicks the REAL button, so the theme's form, variant and cart drawer do the work. */
  function stickyBar() {
    var atc = $('[data-product-blocks] [name=add], [data-product-blocks] .add-to-cart');
    if (!atc || $('.sg-lca-sticky')) return;
    var bar = document.createElement('div');
    bar.className = 'sg-lca-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML = '<div class="sg-lca-sticky__info"><span class="sg-lca-sticky__frame"></span><span class="sg-lca-sticky__price"></span></div>' +
      '<button type="button" class="sg-lca-sticky__btn">Add to cart</button>';
    document.body.appendChild(bar);
    var btn = $('.sg-lca-sticky__btn', bar);

    function sync() {
      var price = ($('[data-product-price]') || {}).textContent || '';
      $('.sg-lca-sticky__price', bar).textContent = price.replace(/\s+/g, ' ').trim();
      // the choices the shopper actually made (size on landscapes, and the frame)
      var picked = $$('.variant-wrapper:not(.sg-lca-single)').map(function (w) {
        var c = $('input[type=radio]:checked', w); if (!c) return null;
        if (/^unframed$/i.test(c.value)) return 'No frame';
        if (/^print only$/i.test(c.value)) return 'Print only';
        return c.value.replace(/\s*x\s*/i, ' × ').replace(/cm$/i, ' cm');
      }).filter(Boolean);
      $('.sg-lca-sticky__frame', bar).textContent = picked.join(' · ');
      var disabled = atc.disabled || atc.getAttribute('aria-disabled') === 'true';
      btn.disabled = !!disabled;
      btn.textContent = disabled ? (($('[data-add-to-cart-text]', atc) || atc).textContent.trim() || 'Sold out') : 'Add to cart';
    }
    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      document.documentElement.style.setProperty('--lca-sticky-h', on ? bar.offsetHeight + 'px' : '0px');
    }
    btn.addEventListener('click', function () { if (!btn.disabled) atc.click(); });

    var past = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        past = !e.isIntersecting && e.boundingClientRect.top < 0;   // scrolled PAST it, not still above it
        setVisible(past && window.innerWidth <= 768);
      }, { threshold: 0 }).observe(atc);
    }
    window.addEventListener('resize', function () { setVisible(past && window.innerWidth <= 768); });
    document.addEventListener('change', function (e) { if (e.target.closest('.variant-wrapper')) setTimeout(function () { sync(); framePrices($('.sg-lca-frames')); }, 60); });
    new MutationObserver(sync).observe(atc, { attributes: true, childList: true, subtree: true });
    var pr = $('[data-product-price]'); if (pr) new MutationObserver(sync).observe(pr, { childList: true, characterData: true, subtree: true });
    sync();
  }

  /* A feature-line bullet that wraps to the start of a new row is hidden, so no row
     ends or starts with a stray dot. */
  function tidyFeatures() {
    var spans = $$('.sg-lca-features > span'); if (!spans.length) return;
    spans.forEach(function (sp, i) {
      var dot = $('i', sp); if (!dot) return;
      dot.style.display = (i > 0 && sp.offsetTop > spans[i - 1].offsetTop + 2) ? 'none' : '';
    });
  }

  /* "Selected: White · R8,950" under the frame tiles */
  function selectedLine(fw) {
    if (!fw) return;
    var line = $('.sg-lca-selected');
    if (!line) { line = document.createElement('p'); line.className = 'sg-lca-selected'; line.setAttribute('aria-live', 'polite'); fw.parentNode.insertBefore(line, fw.nextSibling); }
    var c = $('input[type=radio]:checked', fw);
    var price = (($('[data-product-price]') || {}).textContent || '').replace(/\s+/g, ' ').trim();
    var shown = c ? (/^print only$/i.test(c.value) ? 'Premium Canvas Print Only, unmounted, unframed' : /^unframed$/i.test(c.value) ? 'Premium Canvas, mounted, unframed' : 'Premium Canvas, mounted, ' + c.value.replace(/\s+Look$/i, '') + ' floater frame') : '';
    line.innerHTML = c ? 'Selected: <b>' + shown + '</b>' + (price ? ' &middot; ' + price : '') : '';
  }

  /* Prices read "R7,495" like the mockup. The theme writes "R7495.00" on every variant
     change, so the main price is re-formatted after each write (display only). */
  function fmt(t) {
    var m = /^\s*R\s?([\d,]+)\.(\d\d)\s*$/.exec(t || '');
    if (!m) return null;
    var whole = m[1].replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'R' + whole + (m[2] === '00' ? '' : '.' + m[2]);
  }
  function priceFormat() {
    var el = $('[data-product-price]'); if (!el) return;
    var apply = function () { var n = fmt(el.textContent); if (n && el.textContent.trim() !== n) el.textContent = n; };
    apply();
    new MutationObserver(apply).observe(el, { childList: true, characterData: true, subtree: true });
  }

  /* The dispatch box (live date + reviews pop-up) moves above Add to Cart as the grey box.
     Only the South African box: overseas visitors get their own dispatch copy, untouched. */
  function dispatchBox() {
    var box = $('[data-product-blocks] .sg-dispatch');
    var atc = $('[data-product-blocks] .add-to-cart');
    if (!box || !atc || !$('.sg-dispatch__free', box)) return;
    var anchor = atc.closest('.payment-buttons') || atc;
    anchor.parentNode.insertBefore(box, anchor);
    box.classList.add('sg-lca-box');
    var free = $('.sg-dispatch__free', box); if (free) free.textContent = 'Free nationwide delivery';
    // "Estimated Dispatch Date:" -> "Estimated dispatch:" (the dispatch script may rewrite the
    // label later, e.g. "Soonest ...", so this re-applies whenever it changes; the date is untouched)
    var d = $('.sg-dispatch__date', box);
    var tidy = function () {
      if (!d || !d.firstChild || d.firstChild.nodeType !== 3) return;
      var t = d.firstChild.textContent, n = t.replace(/\s*Dispatch Date:\s*$/i, ' dispatch: ');
      if (n !== t) d.firstChild.textContent = n;
    };
    tidy(); if (d) new MutationObserver(tidy).observe(d, { childList: true, characterData: true, subtree: true });
  }

  /* Size buttons read "70 × 140 cm" (display only; the option value is unchanged). */
  function sizeLabels() {
    $$('.variant-wrapper:not(.sg-lca-frames):not(.sg-lca-single) .variant-input label').forEach(function (l) {
      if (l.children.length) return;
      l.textContent = l.textContent.replace(/\s*x\s*/i, ' × ').replace(/(\d)cm\s*$/i, '$1 cm');
    });
  }

  /* The feature line sits under the size choice. */
  function placeFeatures() {
    var f = $('.sg-lca-features'); if (!f) return;
    var after = $('.sg-lca-spec') || $('.variant-wrapper:not(.sg-lca-single):not(.sg-lca-frames)');
    var host = f.closest('.product-block') || f;
    if (after && after.parentNode) after.parentNode.insertBefore(host, after.nextSibling);
  }

  function init() {
    var blocks = $('[data-product-blocks]'); if (!blocks) return;
    document.documentElement.classList.add('sg-lca');
    specLine();
    var fw = frameCards();
    framePrices(fw);
    renameTabs();
    priceFormat();
    selectedLine(fw);
    dispatchBox();
    placeFeatures();
    sizeLabels();
    document.addEventListener('change', function (e) { if (e.target.closest('.variant-wrapper')) setTimeout(function () { selectedLine($('.sg-lca-frames')); }, 80); });
    stickyBar();
    tidyFeatures();
    window.addEventListener('resize', tidyFeatures);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
